import { badgeVariants } from "@/components/ui/badge";
import type { Device } from "@/types/device";

// A device registered by a development build of the Appio app (openapi-dashboard.yaml, "The /v1 API").
const DEV_DEVICE_ID_PREFIX = "dev_dvc_";

interface DevDeviceBadgeProps {
  deviceId: Device["id"];
}

/**
 * Tags a dev device. Renders nothing for any other device, so an organization with only
 * production devices never sees it. A span, not <Badge>'s div, because it sits inside a
 * link and a heading.
 */
export function DevDeviceBadge({ deviceId }: DevDeviceBadgeProps) {
  if (!deviceId.startsWith(DEV_DEVICE_ID_PREFIX)) return null;

  return (
    <span
      className={badgeVariants({ variant: "outline" })}
      title="Development build. Notifications go through the APNs / FCM sandbox."
    >
      Dev
    </span>
  );
}
